import * as React from 'react';

import { cn } from '@shadcn/lib/utils';

type IInputProps = React.ComponentProps<'input'>;

const Input = React.forwardRef<HTMLInputElement, IInputProps>(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        'file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground focus-visible:outline-none disabled:cursor-not-allowed',
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = 'Input';

export type { IInputProps };
export { Input };
